module.exports = require("./build/loading-bar.js");
require("./build/loading-bar.css");


//////////////////
// WEBPACK FOOTER
// angular-loading-bar (bower component)
// module id = 1010
// module chunks = 1